import './accreditation-cards.scss';
import './accreditation-cards.html.twig';

export default function () {
  const wrappers = document.querySelectorAll('.accreditation-cards');
  wrappers.forEach(wrapper => {
    const countryFilter = wrapper.querySelector('select.accreditation-cards__filters__filter');
    const cardsWrapper = wrapper.querySelector('.accreditation-cards__cards');
    const tabs = wrapper.querySelectorAll('[role="tab"]');
    const paragraphID = wrapper.getAttribute('data-paragraph-id');
    if (!cardsWrapper) {
      return;
    }

    let countryFilterValue, tabValue = 'all';

    // Pagination.
    const showMore = wrapper.querySelector('.accreditation-cards__show-more a');
    if (showMore) {
      showMore.addEventListener('click', async (e) => {
        e.preventDefault();
        // Check if has page parameter.
        // If not, first page.
        const page = e.target.dataset.page ? (parseInt(e.target.dataset.page) + 1) : 1;
        // Update page parameter.
        showMore.dataset.page = page;
        // Ajax request to custom form route.

        // Process response.
        const accreditationCards = await fetch(`/api/ciob-degrees/show-more/${showMore.dataset.paragraph}/${page}`);
        const json = await accreditationCards.json();

        if(json && json.html) {
          cardsWrapper.innerHTML += json.html;
          if (!json.showMoreButton) {
            showMore.remove();
          }
        }
      });
    }

    // Tabs implementation
    tabs.forEach(tab => {
      tab.addEventListener('click', async (e) => {

        // Update active state for tabs
        tabs.forEach(t => {
          t.setAttribute('aria-selected', 'false');
          t.classList.remove('active');
        });
        tab.setAttribute('aria-selected', 'true');
        tab.classList.add('active');
        tabValue = tab.getAttribute('data-tab-type');

        // If countryFilter is not present, default its value to 'all'
        if (countryFilter) {
          countryFilterValue = countryFilter.value;
        } else {
          countryFilterValue = 'all';
        }

        // Fetch and update cards based on the selected tab and country filter
        const response = await fetch(`/api/ciob-degrees/filter/${paragraphID}/${tabValue}/${countryFilterValue}`);
        const json = await response.json();

        if (json && json.html) {
          cardsWrapper.innerHTML = json.html;
          // Check if the 'Show More' button should be removed or updated
          if (!json.showMoreButton && showMore) {
            showMore.remove();
          }
        }
      });
    });

    // Filters implementation
    if (countryFilter) {
      countryFilter.addEventListener('change', async (e) => {
        countryFilterValue = e.target.value;
        const response = await fetch(`/api/ciob-degrees/filter/${paragraphID}/all/${countryFilterValue}`);
        const json = await response.json();

        if(json && json.html) {
          cardsWrapper.innerHTML = json.html;

          // Update tab visibility based on available_types
          if (json.available_types && tabs) {
            tabs.forEach(tab => {
              const tabType = tab.getAttribute('data-tab-type');
              if (tabType !== 'all') {
                if (json.available_types[tabType] === true) {
                  tab.classList.remove('hidden');
                } else {
                  tab.classList.add('hidden');
                }
                tab.setAttribute('aria-selected', 'false');
                tab.classList.remove('active');
              } else {
                tab.setAttribute('aria-selected', 'true');
                tab.classList.add('active');
              }
            });
          }

          if (!json.showMoreButton) {
            showMore.remove();
          }
        }
      });
    }
  });
}
